export const getDateAsLocal = date => {
  const timezoneOffset = new Date().getTimezoneOffset() * 60 * 1000
  const utcDateInMilliSeconds = new Date(date).getTime() + timezoneOffset
  return new Date(utcDateInMilliSeconds)
}

export const getFormattedDate = date => {
  return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${(
    '0' + date.getDate()
  ).slice(-2)}`
}
